let get_mail = "";
let get_token = "";


$(window).on('load', function () {
    let requestPWButton = document.getElementById("submit_reset");

    requestPWButton.addEventListener("click", function (event) {
        document.getElementById("submit_reset").classList.add("disabled");
        resetPassword(event);
    });
});

function resetPassword(event) {
    event.preventDefault();
    grecaptcha.ready(function() {
        grecaptcha.execute('6LcYFW0dAAAAAKlddVzW2Gy7Y8VHKTJ4q7R1OlnI', {action: 'request_password_reset'}).then(function(token) {
            // Add your logic to submit to your backend server here.
            get_token = token;
            get_mail = document.getElementById("input_email").value;

            requestResetPassword();
        });
    });
}

function afterRequestResetPassword(res) {
    document.getElementById("submit_reset").classList.remove("disabled");

    if (res.success !== 1) {
        document.getElementById("forgotPasswordError").textContent = res.msg;
    } else {
        document.getElementById("mail_txt").innerHTML = res.msg;
        $('#submit_reset').hide();
    }
}